import * as Yup from "yup";
import { specialCharactersNotAllowedValidation } from "../../../helpers/constants/commonValidationSchemaUtils";
import { KeyValueMap } from "../../../redux/slices/appState/models";
import { BulkCreateProgramDownloadFormKey, BulkProcessFormKey } from "./Models";

export const BulkTransferSearchParticipantSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [BulkProcessFormKey.bulkProcessName]: specialCharactersNotAllowedValidation(
      commonValidationMessages.requiredValidation,
      commonValidationMessages.fieldContainsInvalidCharactersErrorMessage,
    ).default(""),

    [BulkProcessFormKey.file]: Yup.mixed().required(
      commonValidationMessages.uploadFileRequiredMessage,
    ),
  });

export const BulkCreateProgramDownloadTemplateSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [BulkCreateProgramDownloadFormKey.clientId]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
  });
